import { render } from "./DynamicChatRoomThread.vue.js?vue&type=template&id=0fb7f2b0&scoped=true!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicChatRoomThread.vue?vue&type=template&id=0fb7f2b0&scoped=true"
import script from "./DynamicChatRoomThread.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicChatRoomThread.vue?vue&type=script&lang=js"
export * from "./DynamicChatRoomThread.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicChatRoomThread.vue?vue&type=script&lang=js"

import "./DynamicChatRoomThread.vue.scss?vue&type=style&index=0&id=0fb7f2b0&lang=scss&scoped=true!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicChatRoomThread.vue?vue&type=style&index=0&id=0fb7f2b0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fb7f2b0"],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/chat-room-page/DynamicChatRoomThread.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0fb7f2b0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0fb7f2b0', __exports__)) {
    api.reload('0fb7f2b0', __exports__)
  }
  
  module.hot.accept("./DynamicChatRoomThread.vue.js?vue&type=template&id=0fb7f2b0&scoped=true!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicChatRoomThread.vue?vue&type=template&id=0fb7f2b0&scoped=true", () => {
    api.rerender('0fb7f2b0', render)
  })

}


export default __exports__